module.exports = __webpack_public_path__ + "img/icon_tap_03.de2c030a.svg";